<template>
  <div class="flex flex-col min-h-screen w-full bg-white">
    <cabecera-gob-mx />

    <main class="flex-1 p-10 mx-auto max-w-5xl space-y-5">
      <h1 class="text-5xl font-bold pt-20">
        Solicitud de borrado de datos
      </h1>
      <p>
        Para solicitar que se borren todos sus datos de la plataforma <b>Apporta</b>, 
        publicada por el Laboratorio Nacional de Geointeligencia (GeoInt), 
        por favor, siga los siguientes pasos:
      </p>
      <ol class="list-decimal pl-10">
        <li>Inicie sesión en la aplicación con su usuario y contraseña.</li>
        <li>En el menú seleccione "Mi perfil"</li>
        <li>En la información de su perfil vaya hasta la parte de abajo y verá un botón "Borrar cuenta".</li>
        <li>Al hacer clic en el botón "Borrar cuenta" se le mostrará una ventana de advertencia/confirmación de que se eliminará su cuenta.</li>
        <li>En un plazo no mayor de 48 horas se eliminará su cuenta y todos los registros asociados a ella, inluyendo los archivos multimedia que haya subido.</li>
      </ol>

      <h2 class="text-3xl font-bold pt-5">
        Solicitud por correo
      </h2>
      <p>
        Alternativamente, puede solicitar el borrado de datos mediente correo electrónico.
      </p>
      <ol class="list-decimal pl-10">
        <li>Envíe un correo a la dirección app.apporta@gmail.com con el asunto "Solicitud de borrado de datos".</li>
        <li>En el cuerpo del correo, por favor, especifique el correo electrónico con el que se registró en la aplicación.</li>
        <li>(Opcional) Especifique en el cuerpo del correo el motivo por el cual desea dejar de participar en la plataforma.</li>
        <li>En un plazo no mayor de 48 horas un administrador se pondrá en contacto con usted.</li>
        <li>Cuando el administrador se comunique le hará unas preguntas de verificación para asegurar que es el dueño de la cuenta a borrar.</li>
        <li>Una vez confirmada la pertenencia de la cuenta se procederá a dar de baja del sistema.</li>
        <li>En un plazo no mayor de 48 horas se eliminará su cuenta y todos los registros asociados a ella, inluyendo los archivos multimedia que haya subido.</li>      
      </ol>
    </main>
    <piedepagina-gob-mx />
  </div>
</template>

<style scoped>
</style>

<script>
import CabeceraGobMx from "./CabeceraGobMx.vue";
import PiedepaginaGobMx from "./PiedepaginaGobMx.vue";

export default {
  data() {
    return {};
  },
  components: {
    CabeceraGobMx,
    PiedepaginaGobMx,
  },
  computed: {},
  methods: {},
};
</script>